<template>
  <div class="default-layout">
    <LayoutTheHeader />
    <div class="container pb-tiny default-layout-content">
      <div class="flex relative flex-wrap  -mx-tiny">
        <div class="block w-full p-0">
          <PressMobileMenu />
        </div>
      </div>
      <div>
        <div class="relative">
          <slot class="default-layout-content" />
        </div>
      </div>
    </div>
    <LayoutTheFooter />
    <SharedCookieBanner />
  </div>
</template>

<script>
export default {
  head () {
    return {
      htmlAttrs: {
        lang: this.$i18n.locale
      },
      link: [
        this.canonical()
      ]
    }
  },
  methods: {
    canonical () {
      return {
        rel: 'canonical',
        href: this.$route.path
      }
    }
  }
}
</script>

  <style lang="postcss" scoped>
  .default-layout {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .default-layout-content {
      flex-grow: 1;
    }
  }
  </style>

  <style>
  *,
  *:before,
  *:after {
    box-sizing: border-box;
    margin: 0;
  }
  </style>
